import { ModuleDefault } from '../default'

export class Create extends ModuleDefault {
  public create(merchantId: string, objBody) {
    const body = objBody
    return this.request.post(`${this.setup.urlDash}/merchants/${merchantId}/accounts`, body)
  }
}
